import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router";

import './style/Login.css';

import pingItApi from "../api/pingItApi";
import { AuthContext } from "./utils/AuthContext";

import Logo from './img/pingit_logo.png';

const Login = () => {
    const {login} = useContext(AuthContext);

    const [username, setUsername] = useState("");
    const [password, setPassword] =  useState("");
    const [text, setText] = useState("Inserire credenziali.");

    const navigate = useNavigate();

    const handleSubmit = async () => {
        if(username.trim().length === 0 || password.trim().length === 0) return setText("Credenziali non valide.");
        
        await pingItApi.post("/user/login", {
            username,
            password
        }, {validateStatus: () => true,
            withCredentials: true
        }).then(async (res) => {
            if(!res.data.success) return setText(res.data.message);

            login(res.data.user);
            navigate('/', {replace: true})
        })
    }

    useEffect(() => {
        pingItApi.get('/user/me', {withCredentials: true, validateStatus: () =>  true}).then((res) => {
            if(res.data.success) navigate('/');
        })
    }, [navigate])

    return(
        <div style={{
            width: '100%', 
            height: '100%', 
            backgroundColor: '#2274A5', 
            position: 'absolute', 
            zIndex: '3',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
        }}>
            <div style={{backgroundColor: 'white', borderRadius: '15px', padding: '10px', marginBottom: '30px'}}>
                <img src={Logo} alt="logo" />
            </div>
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <input placeholder="Utente" onChange={(e) => setUsername(e.target.value)} className="loginInput"  type="email" name="email" id="email" />
                <input placeholder="Password" onChange={(e) => setPassword(e.target.value)} className="loginInput" type="password" name="password" id="password" />
                <input onClick={handleSubmit} className="loginInput button" type="button" value="Accedi" />
                <p style={{textAlign: 'center', color: 'white', fontWeight: 'bold'}}>{text}</p>
            </div>
            
        </div>
    )
}

export default Login;